import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

function useVehicles() {
  return useQuery({
    queryKey: ['vehicles'],
    queryFn: async () => {
      const { data } = await axios.get('/api/vehicles');

      return data;
    },
  });
}

function useStations() {
  return useQuery({
    queryKey: ['stations'],
    queryFn: async () => {
      const { data } = await axios.get('/api/stations');

      return data;
    },
  });
}

function useVehicle(id, operator, formFactor) {
  return useQuery({
    queryKey: ['vehicles', id, operator],
    queryFn: async () => {
      const params = new URLSearchParams({
        id,
        operator,
      });

      if (formFactor) {
        params.set('formFactor', formFactor);
      }

      const { data } = await axios.get(`/api/vehicles/id?${params.toString()}`);

      return data;
    },
    enabled: !!id && !!operator,
  });
}

function useStation(id, operator, formFactor) {
  return useQuery({
    queryKey: ['stations', id, operator, formFactor],
    queryFn: async () => {
      const params = new URLSearchParams({
        id,
        operator,
      });

      if (formFactor) {
        params.set('formFactor', formFactor);
      }

      const { data } = await axios.get(`/api/stations/id?${params.toString()}`);
      
      return data;
    },
    enabled: !!id && !!operator,
  });
}

function useAvailableCommunes() {
  return useQuery({
    queryKey: ['communes'],
    queryFn: async () => {
      const { data } = await axios.get('/api/download/available-communes');

      return data;
    },
  });
}

function useAddress(longitude, latitude, lang) {
  const { data, isLoading, error } = useQuery({
    queryKey: ['address', longitude, latitude, lang],
    queryFn: async () => {
      const res = await axios.get(
        `https://api.maptiler.com/geocoding/${longitude},${latitude}.json?key=${
          import.meta.env.VITE_MAPTILER_TOKEN
        }&limit=1&country=be&language=${lang}&types=address`,
      );

      return res.data?.features?.[0]?.place_name
        ?.replace(', België', '')
        ?.replace(', Belgique', '')
        ?.replace(', Belgium', '') || null;
    },
    keepPreviousData: false,
  });

  return {
    data: isLoading ? null : data,
    isLoading,
    error,
  };
}

export {
  useAvailableCommunes,
  useStation,
  useStations,
  useVehicle,
  useVehicles,
  useAddress,
};